export default __webpack_public_path__ + "static/TopAttorneys-6d816a0c323f7506c0df4144beb1cf40.png";